<script>
import AnkhList from "@/components/list/AnkhList.vue";
import TableList from "@/components/table-list/TableList.vue";
import DictText from "@/components/dict/DictText.vue";

export default {
  name: "Test",
  components: {DictText, TableList, AnkhList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      showDialog: false,
    }
  },
  mounted() {

  },
  methods: {
    handleSearch() {
      for (let i = 0; i < 1; i++) {
        this.tableData.push({macCode: "测试"})
      }
    }
  }
}
</script>

<template>
  <ankh-list :show-btn-group="false" :show-search-form="false">
    <template #table="{height}">
      <table-list
          :fixedHeight="true"
          :height="height"
          ref="list"
          row-key="id"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="macCode" label="mac码"/>
        <el-table-column prop="linkCount" label="在线连接人数" />
        <el-table-column prop="content" label="创建时间">
          <template v-slot="{row}">
            {{row.createTime | formatDate('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template v-slot="{row}">
            <dict-text dict-flag="MAC_CODE_STATUS" :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link v-if="row.status === 'close'" type="primary" :underline="false" @click="handleUnlock(row)">解锁</el-link>
              <el-link v-else type="danger" :underline="false" @click="handleLock(row)">锁定</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<style scoped>

</style>
